import React from 'react';

import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

const idPrefix = 'messages';
const idPostfix = 'indicator';

const { captionBold } = EquipUITheme.typography;

interface MessageDotIndicatorProps {
  id: string;
  isMentioned?: boolean;
  isShowDot?: boolean;
  dotColor?: 'marigold' | 'red';
}

const MessageDotIndicator = React.forwardRef<
  HTMLInputElement,
  MessageDotIndicatorProps
>(
  (
    {
      id,
      isMentioned,
      isShowDot = false,
      dotColor = 'marigold',
    }: MessageDotIndicatorProps,
    ref?: React.ForwardedRef<HTMLInputElement>,
  ) => {
    const containerProps = {
      alignItems: 'flex-start',
      backgroundColor: isMentioned ? 'tertiary.marigold.base' : 'secondary.5',
      borderRadius: '10px',
      gridGap: '10px',
      minHeight: '18px',
      padding: '4px 8px',
    };

    const newMessageTitleProps = {
      color: isMentioned ? 'neutral' : 'secondary',
    };

    if (isShowDot) {
      return (
        <ChakraBox
          backgroundColor={EquipUIFireflyV2Theme.colors?.[`${dotColor}`][100]}
          borderRadius="8px"
          height="6px"
          width="6px"
        >
          &nbsp;
        </ChakraBox>
      );
    }

    return (
      <ChakraFlex
        direction="column"
        id={`${idPrefix}-new-message-container__${id}__${idPostfix}`}
        ref={ref}
        textAlign="center"
        {...containerProps}
      >
        <ChakraText
          id={`${idPrefix}-new-message__${id}__${idPostfix}`}
          {...newMessageTitleProps}
          {...captionBold}
        >
          New messages
        </ChakraText>
      </ChakraFlex>
    );
  },
);

MessageDotIndicator.displayName = 'NewMessageIndicator';

export default MessageDotIndicator;
